import styled from "styled-components";
import { THEME } from "../PageContents/styles";

export const Container = styled.div``;

export const List = styled.div<{
    open: boolean;
}>`
    visibility: ${(p) => (p.open ? "visible" : "hidden")};
    z-index: 15;
    position: fixed;
    top: 15vh;
    width: 40vw;
    margin-right: -20vw;
    max-height: 75vh;
    overflow-x: hidden;
    overflow-y: auto;
    text-align: right;
    color: ${(p) => THEME[p.theme]["code"]["color"]};
    background-color: ${(p) => THEME[p.theme]["code"]["bgColor"]};
    border: 3px solid ${(p) => THEME[p.theme]["code"]["borderColor"]};
    border-radius: 0;
    white-space: nowrap;

    @media (max-width: 600px) {
        width: 90vw;
        right: 5vw;
        margin-right: 0;
    }
`;

export const Item = styled.div<{
    darkTheme: boolean;
    active: boolean;
    primary: boolean;
}>`
    display: flex;
    flex-direction: row;
    cursor: ${(p) => {
        return p.active ? "default" : "pointer";
    }};
    user-select: none;
    padding: 5px 30px 5px 5px;
    border-bottom: 1px solid ${(p) => THEME[p.theme]["code"]["borderColor"]};
    color: ${(p) => {
        if (p.primary) {
            return THEME[p.theme]["a"]["color"];
        }

        if (p.active) {
            return THEME[p.theme]["blockQuote"]["color"];
        }

        return THEME[p.theme]["text"]["color"];
    }};

    background-color: ${(p) => {
        if (p.active) {
            return THEME[p.theme]["blockQuote"]["bgColor"];
        }

        return "transparent";
    }};

    &:first-child {
        padding-top: 5px;
    }

    &:last-child {
        border-bottom: 0;
        padding-bottom: 5px;
    }

    &:hover {
        color: ${(p) => {
            if (p.primary) {
                return THEME[p.theme]["a"]["color"];
            }

            return THEME[p.theme]["blockQuote"]["color"];
        }};
        background-color: ${(p) => THEME[p.theme]["blockQuote"]["bgColor"]};
    }

    [lang="ar"] {
        font-size: 15px;
    }
`;

export const Text = styled.div<{
    indent: number;
}>`
    position: relative;
    margin-right: ${(p) => p.indent * 40}px;
    font-weight: 500;
    font-size: 16px;

    &:before {
        display: ${(p) => (p.indent === 0 ? "none" : "block")};
        position: absolute;
        content: "\u2022";
        right: -18px;
        top: 1px;
    }
`;
